import { makeStyles } from "$components/mui-styles";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import DownloadReportModal from "./download-report-modal";
import PrintableDoctorReport from "./printable-doctor-report";
import type { HistoricPatientEvent } from "./types";

const useDownloadReportStyles = makeStyles((theme) => ({
  downloadReport: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    cursor: "pointer",
    border: 0,
    padding: 0,
    outline: "none",
    background: "none",
    "&:focus,&:active,&:hover": {
      textDecoration: "underline",
      color: theme.palette.primary.main,
    },
  },
}));

interface Props {
  date: string;
  patient: React.ComponentProps<typeof PrintableDoctorReport>["patient"] & {
    cardId: string;
  };
  historicEvents: HistoricPatientEvent[];
  referrals: Array<{
    facilityId?: string | null;
    freeTextFacility?: string | null;
    reasons: string[];
  }>;
  clinicName: string;
}

export const DownloadReportButton = ({
  date,
  historicEvents,
  referrals,
  patient,
  clinicName,
}: Props) => {
  const [shouldPrint, setShouldPrint] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [reportOption, setReportOption] = useState(null);
  const classes = useDownloadReportStyles();

  const onSubmitReportOption = (opt) => {
    setReportOption(opt);
    setShouldPrint(true);
    setOpenModal(false);
  };

  return (
    <>
      <DownloadReportModal
        isOpen={!!openModal}
        onClose={() => setOpenModal(false)}
        onSubmit={(opt) => onSubmitReportOption(opt)}
      />
      <button
        className={classes.downloadReport}
        onClick={() => setOpenModal(true)}
        type="button"
      >
        <FormattedMessage
          id="patient.history.downloadReport"
          defaultMessage="Download Report"
        />
      </button>
      {shouldPrint && patient && (
        <PrintableDoctorReport
          date={date.replaceAll(" ", "")}
          cardId={patient.cardId}
          clinicName={clinicName}
          historicEvents={historicEvents}
          referrals={referrals}
          patient={patient}
          reportOption={reportOption}
          onAfterPrint={() => {
            setShouldPrint(false);
          }}
        />
      )}
    </>
  );
};
